export default "__VITE_ASSET__COYWeoqB__"